import React from "react";
import { Trans } from "@lingui/macro";
import { Link } from "react-router-dom";
import classes from "./AppHeaderLinksStyles.module.scss";
import { HeaderLink } from "./HeaderLink";
import "./Header.css";
import logoImg from "./images/longLogo-min.png";
import { Stack } from "@mui/material";
import Button from "components/Button/Button";
import Close from "./images/close.svg";
import { AppHeaderUser } from "./AppHeaderUser";
import { ConnectWalletButton } from "../Common/ConnectWalletButton/ConnectWalletButton";
import { useWeb3React } from "@web3-react/core";
// import cadtitle from "img/cadence.svg";
type Props = {
  small?: boolean;
  clickCloseIcon: () => void;
  openSettings: () => void;
  redirectPopupTimestamp: number;
  showRedirectModal: (to: string) => void;
  disconnectAccountAndCloseSettings: any;
  setWalletModalVisible: any;
};

export function AppHeaderLinks({
  small,
  openSettings,
  clickCloseIcon,
  redirectPopupTimestamp,
  showRedirectModal,
  disconnectAccountAndCloseSettings,
  setWalletModalVisible,
}: Props) {
  const { active, account } = useWeb3React();

  return (
    <div>
      {small ? (
        <>
          <div className={classes.headerMenuWrapper}>
            <Link to="/">
              <img width={168} height={36} src={logoImg} alt="CAD Logo" />
            </Link>
            <div onClick={() => clickCloseIcon()}>
              <img src={Close} alt="" />
            </div>
          </div>
          <div className={classes.buttonWrapper}>
            {!active || !account ? (
              <ConnectWalletButton className={classes.button} onClick={() => setWalletModalVisible(true)}>
                {<Trans>Connect Wallet</Trans>}
              </ConnectWalletButton>
            ) : (
              <AppHeaderUser
                disconnectAccountAndCloseSettings={disconnectAccountAndCloseSettings}
                setWalletModalVisible={setWalletModalVisible}
              />
            )}
          </div>

          <div className={classes.headerLinksWrapper}>
            {/* <HeaderLink
              to="/dashboard"
              redirectPopupTimestamp={redirectPopupTimestamp}
              showRedirectModal={showRedirectModal}
              activeClassName={classes.activeLink}
              className={classes.link}
              onClick={() => clickCloseIcon()}
            >
              <Trans>Dashboard</Trans>
            </HeaderLink> */}
            <HeaderLink
              to="/earn"
              redirectPopupTimestamp={redirectPopupTimestamp}
              showRedirectModal={showRedirectModal}
              activeClassName={classes.activeLink}
              className={classes.link}
              onClick={() => clickCloseIcon()}
            >
              <Trans>Earn</Trans>
            </HeaderLink>

            {/* <HeaderLink
              to="/trade"
              redirectPopupTimestamp={redirectPopupTimestamp}
              showRedirectModal={showRedirectModal}
              activeClassName={classes.activeLink}
              className={classes.link}
              onClick={() => clickCloseIcon()}
            >
              <Trans>Trade</Trans>
            </HeaderLink> */}

            {active && (
              <div className={classes.settingsButton} onClick={openSettings}>
                Settings
              </div>
            )}
          </div>
        </>
      ) : (
        <Stack direction={small ? "column" : "row"} justifyContent="center" alignItems="center">
          <Stack>
            {/* <HeaderLink
              to="/dashboard"
              redirectPopupTimestamp={redirectPopupTimestamp}
              showRedirectModal={showRedirectModal}
              activeClassName={classes.activeLink}
              className={classes.link}
            >
              <Trans>Dashboard</Trans>
            </HeaderLink> */}
          </Stack>
          <Stack>
            <HeaderLink
              to="/earn"
              redirectPopupTimestamp={redirectPopupTimestamp}
              showRedirectModal={showRedirectModal}
              activeClassName={classes.activeLink}
              className={classes.link}
            >
              <Trans>Earn</Trans>
            </HeaderLink>
          </Stack>
          {/* <Stack>
            <HeaderLink
              to="/smartfunds"
              redirectPopupTimestamp={redirectPopupTimestamp}
              showRedirectModal={showRedirectModal}
            >
              <Trans>SmartFunds</Trans>
            </HeaderLink>
          </Stack>
          <Stack>
            <HeaderLink
              to="/rewards"
              redirectPopupTimestamp={redirectPopupTimestamp}
              showRedirectModal={showRedirectModal}
            >
              <Trans>Rewards</Trans>
            </HeaderLink>
          </Stack> */}
          <Stack>
            {/* <HeaderLink
              to="/trade"
              redirectPopupTimestamp={redirectPopupTimestamp}
              showRedirectModal={showRedirectModal}
              activeClassName={classes.activeLink}
              className={classes.link}
            >
              <Stack>
                <Button variant="semi-clear">
                  <Trans>Trade</Trans>
                </Button>
              </Stack>
            </HeaderLink> */}
          </Stack>
        </Stack>
      )}
    </div>
  );
}
